<div clas="flex flex-row md:flex-col bg-white p-[25px] rounded-lg" mat-dialog-content>

  <ng-container *ngTemplateOutlet="data.descriptionTemplateRef;context:data"></ng-container>

</div>

